const BASE_URL = 'https://afternoon-headland-26184.herokuapp.com/';

const ENDPOINT = {
	ALL_PROJECTS: BASE_URL + 'projects',
	ALL_SERVICES: BASE_URL + 'services',
	SERVICE_DETAIL: BASE_URL + 'services/',
	PROJECT_DETAIL: BASE_URL + 'projects/',
	USER_LOGIN: BASE_URL + 'user/login',
	USER_SIGNUP: BASE_URL + 'user/signup',
	CHECK_AUTH: BASE_URL + 'user/checkauth',
	MY_SERVICES: BASE_URL + 'services/my/list',
	MY_PROJECTS: BASE_URL + 'projects/my/list',
	GET_ALL_CAT: BASE_URL + 'categories',
	MY_INFO: BASE_URL + 'user/my/info',
	PROJECT_BY_CAT: BASE_URL + 'projects/cat/',
	SERVICE_BY_CAT: BASE_URL + 'services/cat/',
	GET_PROFILE: BASE_URL + 'user/profile/',
	PROJECTS_BY_USER: BASE_URL + 'projects/user/',
	SERVICES_BY_USER: BASE_URL + 'services/user/'
}

export default ENDPOINT;